/**
 * Whether the first auto-start should wait for the intro banner (option B: once per mount).
 */
export function shouldDeferInitialStart({ autoStart, showStartBanner, introAlreadyPlayed }) {
    return Boolean(autoStart && showStartBanner && !introAlreadyPlayed);
}

export const GAME_INTRO = Object.freeze({
    countdownFrom: 10,
    countdownIntervalMs: 1000,
    goMs: 800,
    /** Visible countdown phase (10→1, one second each). */
    get countdownMs() {
        return this.countdownFrom * this.countdownIntervalMs;
    },
    get totalMs() {
        return this.countdownMs + this.goMs;
    },
});
